import React, { useState, useEffect } from 'react';

import {
  getUserFacility,
  getFaqs,
  getFaqResponse
} from '@seccon/core/conf/endpoints';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';

import FaqHeader from './components/faqHeader';
import FaqSection from './components/faqSection';

/**
 * FAQ Parent Component
 * Holds all state logic and updates
 */
const Faq = () => {
  const [userFacilityObj, setUserFacilityObj] = useState({});
  const [faqCategories, setFaqCategories] = useState([]);
  const [faqResponses, setFaqResponses] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [isLoadingResponses, setIsLoadingResponses] = useState(true);

  /**
   * When the component mounts get inital data:
   * UserFacility Information and FAQs
   * FAQ page always opens to category one
   */
  useEffect(() => {
    const tenantUri = window.location.origin;
    const fetchUserFacility = `${ tenantUri }${ getUserFacility }`;
    const fetchFAQs = `${ tenantUri }${ getFaqs }`

    setIsLoadingCategories(true);

    Promise.all([fetch(fetchUserFacility), fetch(fetchFAQs)])
      .then(([userFacilityResp, fetchFaqResp]) => Promise.all([userFacilityResp.json(), fetchFaqResp.json()]))
      .then(([userFacilityResp, fetchFaqResp]) => {
        const sortedFaqs = fetchFaqResp.sort((cat1, cat2) => cat1.category.localeCompare(cat2.category));

        if (sortedFaqs.length) {
          setSelectedCategory(sortedFaqs[0].id)
        }

        setUserFacilityObj(userFacilityResp)
        setFaqCategories(sortedFaqs)
      })
      .finally(() => setIsLoadingCategories(false));
  }, []);

  /**
   * When a different FAQ category is selected, get the corresponding answers
  */
  useEffect(() => {
    const tenantUri = window.location.origin;
    const fetchFaqResponse = `${ tenantUri }${ getFaqResponse }${ selectedCategory }`;

    setIsLoadingResponses(true);

    fetch(fetchFaqResponse)
      .then((resp) => resp.json())
      .then((respData) => {
        setFaqResponses(respData);
      })
      .finally(() => setIsLoadingResponses(false));
  }, [selectedCategory]);

  /**
   * Sets the FAQ category
   *
   * @param {String} categoryValue
   */
  const getFaqForCategory = (categoryValue) => {
    setSelectedCategory(categoryValue)
  };

  return (
    <BodyContainer spacing={7}>
      <FaqHeader facilityObj={userFacilityObj} />
      <FaqSection
        categories={faqCategories}
        responses={faqResponses}
        categorySelectCallback={(value) => { getFaqForCategory(value) }}
        selectedCategory={selectedCategory}
        isLoadingCategories={isLoadingCategories}
        isLoadingResponses={isLoadingResponses}
      />
    </BodyContainer>
  );
};

export default Faq;
